// @ts-nocheck
var _dsRunning   = false;
var _dsCooldown  = false;
var _dsDebounce;
var _dsLastSlot  = null; // cache last rendered slot for instant drawer re-render

async function initDeliverySlots() {
  if (_dsRunning || _dsCooldown) {
    // Even if blocked, re-render cached slot into open drawer
    if (_dsLastSlot) renderSlotDisplay(_dsLastSlot.slot, _dsLastSlot.slotdate);
    return;
  }
  _dsRunning = true;

  // 1. Get Assigned Warehouse from cart
  const cartRes = await fetch('/cart.js');
  const cart    = await cartRes.json();
  const storeCode = cart.attributes?.['Assigned Warehouse'] ?? 'FCB';

  // 2. Fetch slots
  let json;
  try {
    const res = await fetch(
      `/apps/booking-api/delivery-slots?store=${storeCode}`,
      { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) }
    );
    json = await res.json();
  } catch (err) {
    console.error('[DeliverySlot] Fetch failed:', err);
    _dsRunning = false;
    return;
  }

  if (!json.success || !json.data?.length) {
    _dsRunning = false;
    return;
  }

  // 3. Nearest slot
  const rawSlots    = json.data[0].slots?.standard ?? [];
  const nearestSlot = getNearestSlot(rawSlots);
  if (!nearestSlot) { _dsRunning = false; return; }

  const slotdate  = nearestSlot.slotdate.split(' ')[0];
  const slotValue = `${slotdate}|${nearestSlot.fromtime}-${nearestSlot.totime}`;
  const slotNote  = `Delivery Slot: ${slotdate} (${nearestSlot.fromtime}–${nearestSlot.totime})`;

  // 4. Only update cart if slot changed
  if (cart.attributes?.['Delivery Slot'] !== slotValue) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: slotNote, attributes: { 'Delivery Slot': slotValue } }),
    });
    console.log('[DeliverySlot] Cart updated:', slotValue);
    _dsCooldown = true;
    setTimeout(function() { _dsCooldown = false; }, 3000);
  }

  // 5. Cache and render
  _dsLastSlot = { slot: nearestSlot, slotdate: slotdate };
  renderSlotDisplay(nearestSlot, slotdate);
  _dsRunning = false;
}

function getNearestSlot(rawSlots) {
  if (!rawSlots?.length) return null;

  const nowIST       = new Date(Date.now() + 5.5 * 60 * 60 * 1000);
  const currentHour  = nowIST.getUTCHours();
  const CUT_OFF_HOUR = 18;

  const sorted      = [...rawSlots].sort((a, b) => a.slotdate.localeCompare(b.slotdate));
  const uniqueDates = [...new Set(sorted.map((s) => s.slotdate.split(' ')[0]))].sort();

  if (uniqueDates.length > 1 && currentHour >= CUT_OFF_HOUR) {
    const nextDate = uniqueDates[1];
    return sorted.find((s) => s.slotdate.startsWith(nextDate)) ?? sorted[0];
  }
  return sorted[0];
}

function renderSlotDisplay(slot, slotdate) {
  // Remove existing
  document.querySelectorAll('#delivery-slot-display').forEach(function(el) { el.remove(); });

  const dateObj = new Date(slotdate + 'T00:00:00');
  const formattedDate = dateObj.toLocaleDateString('en-IN', { month: 'long', day: '2-digit' });

  const html = `
    <div id="delivery-slot-display" style="
      margin: 16px 0;
      padding: 14px 16px;
      border: 1px solid #d4b483;
      border-radius: 6px;
      background: #fdf8f0;
      font-family: inherit;
    ">
      <p style="margin:0 0 4px 0; font-weight:600; font-size:14px; color:#333;">
        🚚 Estimated Delivery
      </p>
      <p style="margin:0; font-size:15px; color:#1a1a1a;">
        <strong>${formattedDate}</strong>
        &nbsp;|&nbsp;
        ${slot.fromtime} – ${slot.totime}
      </p>
    </div>
  `;

  // Cart drawer — before checkout button
  var drawerCheckout = document.querySelector('cart-drawer-component .cart__checkout-button');
  if (drawerCheckout) {
    drawerCheckout.insertAdjacentHTML('beforebegin', html);
  }

  // Cart page — before checkout button inside <main>
  var pageCheckout = document.querySelector('main .cart__checkout-button');
  if (pageCheckout) {
    pageCheckout.insertAdjacentHTML('beforebegin', html);
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', initDeliverySlots);

// Re-run when cart updates
document.addEventListener('cart:update', function(e) {
  var src = e && e.detail && e.detail.data && e.detail.data.source;
  if (src === 'cart-count-sync') return;
  clearTimeout(_dsDebounce);
  _dsDebounce = setTimeout(initDeliverySlots, 500);
});

// Re-render after coupon applied / removed (morphSection wipes the slot card)
document.addEventListener('discount:update', function() {
  clearTimeout(_dsDebounce);
  _dsDebounce = setTimeout(initDeliverySlots, 600);
});

// Re-render when cart drawer opens — uses cache if blocked by cooldown
document.addEventListener('DOMContentLoaded', function() {
  var drawer = document.querySelector('cart-drawer-component');
  if (!drawer) return;
  new MutationObserver(function(mutations) {
    mutations.forEach(function(mut) {
      if (mut.attributeName === 'open' && drawer.hasAttribute('open')) {
        clearTimeout(_dsDebounce);
        _dsDebounce = setTimeout(initDeliverySlots, 200);
      }
    });
  }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
});
